<template>
    <div class="comment">
        <div class="header">
            <template v-if="depart.rate == 1">
                <img src="/images/rates/ants/bad_full.svg" />
            </template>
            <template v-if="depart.rate == 2">
                <img src="/images/rates/ants/good_full.svg" />
            </template>
            <template v-if="depart.rate == 3">
                <img src="/images/rates/ants/cool_full.svg" />
            </template>
            <div class="meta">
                <div class="department">{{ depart.from.name }}</div>
                
                <div class="date">{{ new Date(depart.date).toLocaleDateString('ru-RU') }}</div>
            </div>
        </div>
        <div class="text">{{ depart.comment }}</div>
    </div>
</template>

<script>
export default {
    name: 'Comment',
    data: () => ({
        // пусть извне приходит
        rate: 3,
        text: 'Идейные соображения высшего порядка, а также экономическая повестка сегодняшнего дня, а также свежий взгляд на привычные вещи — безусловно открывает новые горизонты для дальнейших направлений.',
        department: 'Отдел кадров',
        date: '22.09.2021',
    }),
    props: ['depart'],
    components: {},
    computed: {},
    beforeMount() {},
    methods: {},
}
</script>

<style scop>
.comment {
    padding: 16px 30px 24px;
    background: #ffffff;
    margin-bottom: 2px;
}

.comment:first-child {
    border-radius: 30px 30px 0px 0px;
}

.comment img {
    height: 45px;
}

.comment .header {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}

.comment .header .department {
    font-weight: bold;
    font-size: 18px;
    line-height: 1;
    text-align: right;
    color: #1f0303;
    margin-bottom: 10px;
}

.comment .header .date {
    font-size: 18px;
    line-height: 1;
    text-align: right;
}

.comment .text {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 130%;
    color: #4b4949;
}
</style>